import { useNavigate } from 'react-router'
import React from 'react'
import { groupEventsByContext } from 'src/mentor/components/MentorEventsPage/components/utils'
import { MentorEventSummaryComponent } from 'src/mentor/components/MentorEventsPage/MentorEventsComponentsAndHelpers'
import {
  BookedEventTitle,
  EventsPageMainItemsContainer,
  NewEventTypeButton,
} from 'src/mentor/components/MentorEventsPage/MentorEventsPageStyles'

export default function TherapistEventsListing({
  mentorEventTypes,
  associatedClinics,
  effectiveClinicScreeningEntries = [],
  mentorSlug,
  onClickNewEventType,
  onClickExistingEventType,
  onClickClinicFallback,
  disableEventCreation = false,
}) {
  const navigate = useNavigate()
  const groupedEvents = groupEventsByContext(mentorEventTypes)
  const groupedClinicFallbacks = groupEventsByContext(effectiveClinicScreeningEntries)
  const contextIds = Array.from(
    new Set([...Object.keys(groupedEvents), ...Object.keys(groupedClinicFallbacks)]),
  )
  const associatedClinicIds = Array.isArray(associatedClinics)
    ? associatedClinics.map((clinic) => clinic?.id).filter(Boolean)
    : []
  const orderedContextIds = [
    ...contextIds.filter((contextId) => contextId === 'default'),
    ...associatedClinicIds.filter((clinicId) => contextIds.includes(clinicId)),
    ...contextIds.filter(
      (contextId) => contextId !== 'default' && !associatedClinicIds.includes(contextId),
    ),
  ]

  const handleCopyEventLink = (e, item) => {
    // navigator.clipboard.writeText(item?.shortLink);      // will interfere with mobile app
    navigator.clipboard.writeText(
      `${window.location.origin}/mentor/${mentorSlug}/events/${item?.uid}`,
    )
    e.stopPropagation()
  }

  const handleOpenBookingPage = (e, item) => {
    navigate(`/mentor/${mentorSlug}/events/${item?.uid}`)
  }

  return (
    <>
      <>
        {(!Boolean(mentorEventTypes) || mentorEventTypes?.length === 0) &&
          effectiveClinicScreeningEntries?.length === 0 && (
          <BookedEventTitle style={{ margin: '20px' }}>
            You don&apos;t have any events. {disableEventCreation && 'Make your first event now.'}
          </BookedEventTitle>
        )}
        {!disableEventCreation && (
          <div style={{ margin: '20px' }}>
            Tip: You can create 1 free public event to allow people to book a discovery call with
            you.
          </div>
        )}
        {!disableEventCreation && (
          <NewEventTypeButton
            style={{ marginTop: '20px', marginLeft: '20px' }}
            onClick={() => onClickNewEventType(true)}
          >
            + New Event Type
          </NewEventTypeButton>
        )}
      </>
      {orderedContextIds.map((contextId) => (
        <div key={contextId}>
          <div style={{ padding: '24px 24px 0' }}>
            {contextId === 'default'
              ? 'Personal Events (Not offered in clinics):'
              : `Events offered in ${
                  associatedClinics?.find((item) => item?.id === contextId)?.firstName ||
                  associatedClinics?.find((item) => item?.id === contextId)?.title ||
                  associatedClinics?.find((item) => item?.id === contextId)?.name ||
                  'this clinic'
                }:`}
          </div>
          <EventsPageMainItemsContainer>
            {(groupedEvents[contextId] || []).map((item) => (
              <MentorEventSummaryComponent
                key={item.uid}
                item={item}
                onClickEvent={() => {
                  onClickExistingEventType(item)
                }}
                handleCopyEventLink={handleCopyEventLink}
                handleOpenBookingPage={handleOpenBookingPage}
              />
            ))}
            {(groupedClinicFallbacks[contextId] || []).map((item) => (
              <MentorEventSummaryComponent
                key={item.uid}
                item={item}
                onClickEvent={() => {
                  onClickClinicFallback?.(item)
                }}
                readOnlyLabel={item?.sourceLabel}
                helperText={item?.helperText}
                hideActions
                hideAccessAndPricingDetails
              />
            ))}
          </EventsPageMainItemsContainer>
        </div>
      ))}
    </>
  )
}
